import { AttackRange, DamageType, ItemRarity, Weapon } from 'game/core'
import { ItemUI } from 'game/extended/uis/item_uis'

import image from './scout_bow.png'

export const horn_bow: ItemUI<Weapon> = {
    image,
    label: 'Horn bow',
    value: 110,
    item: {
        key: 'horn_bow',
        type: 'weapon',
        rarity: ItemRarity.Epic,
        stats: {
            agility: 40,
            strength: 40
        },
        two_handed: true,
        category: 'bow',
        damageType: DamageType.Ranged,
        range: AttackRange.Ranged,
        energy: 5,
        damage: 18
    }
}
